function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNorwayFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 3470 2168.75",
    style: {
      enableBackground: "new 0 0 3470 2168.75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FF0000"
    },
    points: "0,0 3470,0 3470,2168.75 0,2168.75 0,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    points: "947.461,0 1578.567,0 1578.567,2168.75  947.461,2168.75 947.461,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#FFFFFF"
    },
    points: "0,809.834 3470,809.834 3470,1349.853 0,1349.853  0,809.834  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#003366"
    },
    points: "1110.117,0 1415.911,0 1415.911,2168.75  1110.117,2168.75 1110.117,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#003366"
    },
    points: "0,949.719 3470,949.719 3470,1211.596 0,1211.596  0,949.719  "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorwayFlag);
export default __webpack_public_path__ + "static/media/norway_flag.e6b612948362527e72b0a65a808e4e20.svg";
export { ForwardRef as ReactComponent };